// extracted by mini-css-extract-plugin
export var readonly = "_ix-1";
export var star = "_ix-0";